import {
  IonCard,
  IonCardContent,
  IonCol,
  IonItem,
  IonRow,
  IonText,
  IonThumbnail,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { makePOSTRequest } from "../../request/rawRequest";

import "../generalCSS/stylesheet.css";
import "./List.css";
interface ContainerProps {
  idTheme: number;
  generique: boolean;
  id_videos: Array<any>;
  pictureUrl?: string;
  compID?: string;
  theme?: any;
}

type customVid = {
  quizz: Array<any>;
  pages: Array<any>;
  name: string;
  link: string;
  pictureUrl: string;
  id: string;
  viewed: boolean;
};

const getVideosByTheme = async (id_videos: any) => {
  let vids: any = [];

  await makePOSTRequest("/videos", { _id: id_videos }).then((data) => {
    vids = data;
  });
  vids.sort((a: any, b: any) => a.index - b.index);
  return vids;
};

interface PropsVideoCard {
  video: any;
  idTheme: number;
  href: string;
  pictureUrl?: string;
  compID?: string;
  nextThemeId?: string;
}

const VideoCard: React.FC<PropsVideoCard> = ({
  nextThemeId,
  video,
  idTheme,
  href,
  pictureUrl,
  compID,
}) => {
  let finalHref =
    href +
    "?theme=" +
    idTheme +
    "&id=" +
    video._id +
    "&nextThemes=" +
    nextThemeId;

  if (compID !== undefined && compID.length > 0)
    finalHref += "&compID=" + compID;

  return (
    <IonCard
      key={video._id}
      href={finalHref}
      color="tertiary"
      className="card card-theme ion-no-padding"
    >
      <IonCardContent className={"ion-no-padding"}>
        <IonRow>
          <IonItem lines="none">
            <IonThumbnail>
              <img
                src={video.pictureUrl ?? pictureUrl}
                style={{
                  borderRadius: "100%",
                }}
                alt="image de la vidéo"
              />
            </IonThumbnail>
            <IonText style={{ width: " calc( 100% - 70px)", paddingLeft: 20 }}>
              {video.name}
              <span style={{ color: "green", fontSize: 30 }}>
                {video.viewed && video.viewed === true ? "✔" : ""}
              </span>
            </IonText>
          </IonItem>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};

const ListVideo: React.FC<ContainerProps> = ({
  idTheme,
  generique,
  pictureUrl,
  compID,
  theme,
  id_videos,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const [videoLists, setvideoList] = useState<any[]>([]);
  const isCharSkills = urlParams.get("fetch") === "charSkills";
  const isPrimSkills = urlParams.get("fetch") === "primSkills";

  const videoList: any[] = videoLists;

  useEffect(() => {
    if (generique) {
      setvideoList(theme.videos);
    } else {
      setvideoList([theme]);
    }
  }, []);

  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size="12" size-sm="12" size-lg="12">
        {videoList.map((video, i) => {
          return (
            <VideoCard
              key={i}
              video={video}
              nextThemeId={video.id_nextTheme}
              href={
                generique && (isCharSkills || isPrimSkills) === false
                  ? "videogen"
                  : "video"
              }
              idTheme={idTheme}
              compID={compID}
              pictureUrl={
                generique && (isCharSkills || isPrimSkills) === false
                  ? ""
                  : pictureUrl
              }
            />
          );
        })}
      </IonCol>
      <IonCol size="8">
        <div
          style={{
            backgroundColor: "var(--ion-color-secondary)",
            height: "3px",
          }}
        ></div>
      </IonCol>
    </IonRow>
  );
};

export default ListVideo;
